// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"24f2d5b2","137":"feb7ec5f","171":"2480577f","427":"6343d6bc","428":"4083d170","563":"80f3ee48","759":"fec1fcfd","811":"ad76a683","864":"34efd061","909":"f2dfc697","917":"b83c9aeb","945":"c14866a2","949":"14c32391","973":"47643ae7"}[chunkId] + ".chunk.js";
};